(function($) {
  /**
   * Form label animation
   */

  $('.woocommerce-Input--text').on('blur input focus', function() {
    if (this.value) {
      var name_attr = $(this).attr('id');
      $('form')
        .find('label[for=' + name_attr + ']')
        .addClass('input-focus');
    } else {
      var name_attr = $(this).attr('id');
      $('form')
        .find('label[for=' + name_attr + ']')
        .removeClass('input-focus');
    }
  });

  $('.woocommerce form input:not(.no-animation)').on('focus', function() {
    if (this) {
      var name_attr = $(this).attr('id');
      $('form')
        .find('label[for=' + name_attr + ']')
        .addClass('input-focus');
    } else {
      var name_attr = $(this).attr('id');
      $('form')
        .find('label[for=' + name_attr + ']')
        .removeClass('input-focus');
    }
  });

  $('.woocommerce form input:not(.no-animation)').on('focusout', function() {
    if (this.value) {
      var name_attr = $(this).attr('id');
      $('form')
        .find('label[for=' + name_attr + ']')
        .addClass('input-focus');
    } else {
      var name_attr = $(this).attr('id');
      $('form')
        .find('label[for=' + name_attr + ']')
        .removeClass('input-focus');
    }
  });

  $('.woocommerce form input:not(.no-animation)').each(function() {
    if (this.value) {
      var name_attr = $(this).attr('id');
      $('form')
        .find('label[for=' + name_attr + ']')
        .addClass('input-focus');
    } else {
      var name_attr = $(this).attr('id');
      $('form')
        .find('label[for=' + name_attr + ']')
        .removeClass('input-focus');
    }

    // if ($(this).hasClass("input-date")) {

    //   var input_id = $(this).attr('id');

    //   var input_data_id_value = $("form").find('input[data-id=' + input_id + ']').val();

    //   var input_data_id = $("form").find('input[data-id=' + input_id + ']').attr("data-id");

    //   console.log('Data-id name '+input_data_id);

    //   console.log('Data-id value ' + input_data_id_value);

    //   if (input_data_id_value) {
    //     $("form").find('label[for=' + input_data_id + ']').addClass('input-focus');
    //   } else {
    //     $("form").find('label[for=' + input_data_id + ']').removeClass('input-focus');
    //   }

    // }
  });

  $('.woocommerce-edit-address label, .woocommerce-checkout label').each(
    function() {
      $('form')
        .find('label')
        .addClass('input-focus');
    },
  );

  $('.woocommerce-edit-address, .woocommerce-checkout').on(
    'focusout',
    function() {
      $('form')
        .find('label')
        .addClass('input-focus');
    },
  );

  /* ==== Multiselect ==== */

  // $('#city-directory').multiselect();

  /* ==== WPCF7 ==== */

  /**
   * Input placeholder
   */
  $('.wpcf7-form-control-wrap input').each(function() {
    var wpcf7_placeholder = $(this).attr('placeholder');
    var wpcf7_placeholder_focus =
      '<span class="placeholder">' + wpcf7_placeholder + ' :</span>';

    $(this).focus(function() {
      if (wpcf7_placeholder != undefined) {
        if ($(this).is('#salary') || $(this).is('#price')) {
          $(this).attr('placeholder', 'Sur demande');
        } else {
          $(this).attr('placeholder', '');
        }

        $(this).after(wpcf7_placeholder_focus);
      }
    });

    $(this).focusout(function() {
      if (wpcf7_placeholder != undefined) {
        $(this).attr('placeholder', wpcf7_placeholder);
        $(this)
          .parent()
          .find('span.placeholder')
          .remove();
      }
    });
  });

  /**
   * Checkbox ® formatter
   */
  $(document).ready(function() {
    $('.wpcf7-list-item-label').each(function () {
      var checkbox_text =  $(this).text();
      checkbox_text = checkbox_text.replace('®', '<sup>®</sup>');
       $(this).html(checkbox_text);
    });
  });

  /**
   * Breacrumbs ® formatter
   */
  $('.woocommerce-breadcrumb').each(function () {
    var breacrumb_content =  $(this).text();
    breacrumb_content = breacrumb_content.replace('®', '<sup>®</sup>');
     $(this).html(breacrumb_content);
  });

  /**
   * Phone Input Mask
   */
  var phoneFormat = ['999-999-9999', '9-999-999-9999'];

  function formatPhoneInput(phoneInput, clearMaskOnLostFocus = true) {
    if (phoneInput.length){
      phoneInput.inputmask({
        mask: phoneFormat,
        clearMaskOnLostFocus,
      });
    }
  }

  $(document).ready(function() {
    formatPhoneInput($('#home-phone'));
    formatPhoneInput($('#work-phone'));
    formatPhoneInput($('#other-phone'));
    formatPhoneInput($('#phone-phone'), false);
    formatPhoneInput($('#phone-number-receipt'), false);
  });
})(jQuery);
